import PurchaseResult from './component';

export default PurchaseResult;
